module.exports = __webpack_public_path__ + "img/Health.264dc92b.svg";